import Flickity from "flickity";
import Masonry from "masonry-layout";

const reviewsCarousel = document.querySelector(".reviews-carousel");
const tentsCarousel = document.querySelector(".tents-carousel");
const tentsResponsiveCarousel = document.querySelector(
  ".tents-responsive-carousel"
);
const tentsOverviewCarousel = document.querySelector(
  ".tents-overview-carousel"
);
const projectsCarousel = document.querySelector(".projects-carousel");
const postsCarousel = document.querySelector(".posts-carousel");
const uspCarousel = document.querySelector(".usp-carousel");
const blocksCarousel = document.querySelector(".blocks-carousel");
const TimelineTopCarousel = document.querySelector(".timeline-top-carousel");
const TimelineBottomCarousel = document.querySelector(
  ".timeline-bottom-carousel"
);
const imageCarousel = document.querySelector(".image-carousel");

if (TimelineTopCarousel) {
  var elemTimelineTop = document.querySelector(".timeline-top-carousel");
  var flktyTimelineTop = new Flickity(elemTimelineTop, {
    // options
    selectedAttraction: 0.1,
    friction: 0.8,
    cellAlign: "left",
    prevNextButtons: false,
    pageDots: false,
    wrapAround: false,
  });
}

if (TimelineBottomCarousel) {
  var elemTimelineBottom = document.querySelector(".timeline-bottom-carousel");
  var flktyTimelineBottom = new Flickity(elemTimelineBottom, {
    // options
    asNavFor: ".timeline-top-carousel",
    selectedAttraction: 0.1,
    friction: 0.8,
    cellAlign: "left",
    prevNextButtons: false,
    pageDots: false,
    wrapAround: false,
  });

  var previousButton = document.querySelector(".btn-prev");
  previousButton.addEventListener("click", function () {
    flktyTimelineBottom.previous();
    flktyTimelineTop.previous();
  });

  var nextButton = document.querySelector(".btn-next");
  nextButton.addEventListener("click", function () {
    flktyTimelineBottom.next();
    flktyTimelineTop.next();
  });
}

if (uspCarousel) {
  var elemUsp = document.querySelector(".usp-carousel");
  var flktyUsp = new Flickity(elemUsp, {
    // options
    selectedAttraction: 0.1,
    friction: 0.8,
    cellAlign: "center",
    prevNextButtons: false,
    pageDots: false,
    wrapAround: true,
    autoPlay: 3000,
  });
}

if (blocksCarousel) {
  var elemBlocks = document.querySelector(".blocks-carousel");
  var flktyBlocks = new Flickity(elemBlocks, {
    // options
    selectedAttraction: 0.1,
    friction: 0.8,
    cellAlign: "left",
    prevNextButtons: false,
    pageDots: false,
    wrapAround: true,
    watchCSS: true,
    autoPlay: 3000,
  });
}

if (tentsCarousel) {
  var elemTents = document.querySelector(".tents-carousel");
  var flktyTents = new Flickity(elemTents, {
    // options
    selectedAttraction: 0.1,
    friction: 0.8,
    cellAlign: "left",
    prevNextButtons: false,
    pageDots: false,
    wrapAround: false,
  });

  //    var TentsPreviousButton = document.querySelector('.tents-nav .btn-prev');
  //    TentsPreviousButton.addEventListener('click', function () {
  //        flktyTents.previous();
  //    });
  //
  //    var TentsNextButton = document.querySelector('.tents-nav .btn-next');
  //    TentsNextButton.addEventListener('click', function () {
  //        flktyTents.next();
  //    });
}

if (tentsResponsiveCarousel) {
  var elemResonsiveTents = document.querySelector(".tents-responsive-carousel");
  var flktyResponsiveTents = new Flickity(elemResonsiveTents, {
    // options
    selectedAttraction: 0.1,
    friction: 0.8,
    cellAlign: "left",
    prevNextButtons: false,
    pageDots: false,
    wrapAround: false,
  });

  var TentsResponsivePreviousButton = document.querySelector(
    ".tents-reponsive-nav .btn-prev"
  );
  TentsResponsivePreviousButton.addEventListener("click", function () {
    flktyResponsiveTents.previous();
  });

  var TentsResponsiveNextButton = document.querySelector(
    ".tents-reponsive-nav .btn-next"
  );
  TentsResponsiveNextButton.addEventListener("click", function () {
    flktyResponsiveTents.next();
  });
}

if (reviewsCarousel) {
  var elem = document.querySelector(".reviews-carousel");
  var flktyReviews = new Flickity(elem, {
    // options
    selectedAttraction: 0.1,
    friction: 0.8,
    cellAlign: "center",
    prevNextButtons: false,
    pageDots: false,
    wrapAround: true,
    cellSelector: ".review-item",
  });

  // Use the correct button selectors that match the HTML
  var ReviewsPreviousButton = document.querySelector(".review-custom-prev");
  if (ReviewsPreviousButton) {
    ReviewsPreviousButton.addEventListener("click", function () {
      flktyReviews.previous();
    });
  }

  var ReviewsNextButton = document.querySelector(".review-custom-next");
  if (ReviewsNextButton) {
    ReviewsNextButton.addEventListener("click", function () {
      flktyReviews.next();
    });
  }
}

if (projectsCarousel) {
  var elemProjects = document.querySelector(".projects-carousel");
  var flktyProjects = new Flickity(elemProjects, {
    // options
    selectedAttraction: 0.1,
    friction: 0.8,
    cellAlign: "left",
    prevNextButtons: false,
    pageDots: false,
    wrapAround: false,
    watchCSS: true,
  });

  var ProjectsPreviousButton = document.querySelector(
    ".projects-nav .btn-prev"
  );
  ProjectsPreviousButton.addEventListener("click", function () {
    flktyProjects.previous();
  });

  var ProjectsNextButton = document.querySelector(".projects-nav .btn-next");
  ProjectsNextButton.addEventListener("click", function () {
    flktyProjects.next();
  });
}

if (postsCarousel) {
  var elemPosts = document.querySelector(".posts-carousel");
  var flktyPosts = new Flickity(elemPosts, {
    // options
    selectedAttraction: 0.1,
    friction: 0.8,
    cellAlign: "left",
    prevNextButtons: false,
    pageDots: false,
    wrapAround: false,
    watchCSS: true,
  });

  var PostsPreviousButton = document.querySelector(".posts-nav .btn-prev");
  PostsPreviousButton.addEventListener("click", function () {
    flktyPosts.previous();
  });

  var PostsNextButton = document.querySelector(".posts-nav .btn-next");
  PostsNextButton.addEventListener("click", function () {
    flktyPosts.next();
  });
}

// Flickity x Masonry

// Functie om Flickity-carousel te initialiseren
function initFlickity() {
  var elemTentsOverview = document.querySelector(".tents-overview-carousel");
  if (!elemTentsOverview) return; // Exit if element doesn't exist
  
  var flktyTentsOverview = new Flickity(elemTentsOverview, {
    // options
    selectedAttraction: 0.1,
    friction: 0.8,
    cellAlign: "left",
    prevNextButtons: false,
    pageDots: false,
    wrapAround: false,
    watchCSS: true,
  });

  var TentsOverviewPreviousButton = document.querySelector(
    ".tents-reponsive-nav .btn-prev"
  );
  if (TentsOverviewPreviousButton) {
    TentsOverviewPreviousButton.addEventListener("click", function () {
      flktyTentsOverview.previous();
    });
  }

  var TentsOverviewNextButton = document.querySelector(
    ".tents-reponsive-nav .btn-next"
  );
  if (TentsOverviewNextButton) {
    TentsOverviewNextButton.addEventListener("click", function () {
      flktyTentsOverview.next();
    });
  }
}

// Functie om Masonry-layout te initialiseren
function initMasonry() {
  var gridElement = document.querySelector(".tents-overview-grid");
  if (!gridElement) return; // Exit if element doesn't exist
  
  var msnry = new Masonry(gridElement, {
    itemSelector: ".grid-item",
    percentPosition: true,
  });
}

// Functie om te controleren op de schermgrootte en de juiste lay-out te initialiseren
function checkLayout() {
  // Check if either tents-overview-carousel or tents-overview-grid exists
  var hasOverviewElements = document.querySelector(".tents-overview-carousel") || document.querySelector(".tents-overview-grid");
  if (!hasOverviewElements) return; // Exit if neither element exists
  
  if (window.innerWidth <= 768) {
    initFlickity(); // Schakel Flickity in
  } else {
    initMasonry(); // Schakel Masonry in
  }
}

// Initialisatie
checkLayout();

// Luister naar wijzigingen in de schermgrootte en update de lay-out dienovereenkomstig
window.addEventListener("resize", function () {
  checkLayout();
});

if (TimelineTopCarousel) {
  // slider top
  const FlickityTop = document.querySelector(".flickity-slider--top");

  let flickityTopSlidesSpeed = 2;
  let flickityTopSlides = null;

  flickityTopSlides = new Flickity(FlickityTop, {
    autoPlay: false,
    prevNextButtons: false,
    pageDots: false,
    draggable: false,
    wrapAround: true,
    selectedAttraction: 0.015,
    friction: 0.25,
  });

  flickityTopSlides.x = 0;

  const flickityTopSlidesUpdate = () => {
    if (flickityTopSlides.slides) {
      flickityTopSlides.x =
        (flickityTopSlides.x - flickityTopSlidesSpeed) %
        flickityTopSlides.slideableWidth;
      flickityTopSlides.selectedIndex =
        flickityTopSlides.dragEndRestingSelect();
      flickityTopSlides.updateSelectedSlide();
      flickityTopSlides.settle(flickityTopSlides.x);
    }
    window.requestAnimationFrame(flickityTopSlidesUpdate);
  };

  flickityTopSlidesUpdate();

  // slider center
  const FlickityCenter = document.querySelector(".flickity-slider--center");

  let flickityCenterSlidesSpeed = 1.5;
  let flickityCenterSlides = null;

  flickityCenterSlides = new Flickity(FlickityCenter, {
    autoPlay: false,
    prevNextButtons: false,
    pageDots: false,
    draggable: false,
    wrapAround: true,
    selectedAttraction: 0.015,
    friction: 0.25,
  });

  flickityCenterSlides.x = 0;

  const flickityCenterSlidesUpdate = () => {
    if (flickityCenterSlides.slides) {
      flickityCenterSlides.x =
        (flickityCenterSlides.x - flickityCenterSlidesSpeed) %
        flickityCenterSlides.slideableWidth;
      flickityCenterSlides.selectedIndex =
        flickityCenterSlides.dragEndRestingSelect();
      flickityCenterSlides.updateSelectedSlide();
      flickityCenterSlides.settle(flickityCenterSlides.x);
    }
    window.requestAnimationFrame(flickityCenterSlidesUpdate);
  };

  flickityCenterSlidesUpdate();

  // slider bottom
  const FlickityBottom = document.querySelector(".flickity-slider--bottom");

  let FlickityBottomSlidesSpeed = 3;
  let FlickityBottomSlides = null;

  FlickityBottomSlides = new Flickity(FlickityBottom, {
    autoPlay: false,
    prevNextButtons: false,
    pageDots: false,
    draggable: false,
    wrapAround: true,
    selectedAttraction: 0.015,
    friction: 0.25,
  });

  FlickityBottomSlides.x = 0;

  const FlickityBottomSlidesUpdate = () => {
    if (FlickityBottomSlides.slides) {
      FlickityBottomSlides.x =
        (FlickityBottomSlides.x - FlickityBottomSlidesSpeed) %
        FlickityBottomSlides.slideableWidth;
      FlickityBottomSlides.selectedIndex =
        FlickityBottomSlides.dragEndRestingSelect();
      FlickityBottomSlides.updateSelectedSlide();
      FlickityBottomSlides.settle(FlickityBottomSlides.x);
    }
    window.requestAnimationFrame(FlickityBottomSlidesUpdate);
  };

  FlickityBottomSlidesUpdate();
}

if (imageCarousel) {
  var elemImage = imageCarousel;
  var flktyImage = new Flickity(elemImage, {
    // options
    wrapAround: true,
    prevNextButtons: false,
    pageDots: false,
    cellAlign: "left",
  });
  
  // Look for both possible button class names
  var ImagePreviousButton = document.querySelector(".image-slider-btn-prev") || document.querySelector(".btn-prev-image");
  if (ImagePreviousButton) {
    ImagePreviousButton.addEventListener("click", function () {
      flktyImage.previous();
    });
  }

  var ImageNextButton = document.querySelector(".image-slider-btn-next") || document.querySelector(".btn-next-image");
  if (ImageNextButton) {
    ImageNextButton.addEventListener("click", function () {
      flktyImage.next();
    });
  }
}
